import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { questionIconFor } from '../../../helpers/quiz';
import { MetadataService } from '../../../services/metadata/metadata';
import { QuizService } from '../../../services/quiz/quiz';

export interface QuestionListItem {
  id: string;
  icon: string;
  label: string;
  hasPending?: boolean;
}

@Component({
  selector: 'nr-questions',
  imports: [TranslatePipe],
  templateUrl: './questions.html',
  styleUrl: './questions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QuestionsComponent {
  private readonly metadataService = inject(MetadataService);
  private readonly quizService = inject(QuizService);

  readonly isAdmin = computed(() => this.metadataService.isTeacher());

  readonly questionItems = computed<QuestionListItem[]>(() =>
    this.quizService.visibleQuizzes().map(({ quiz, isPending }) => ({
      id: quiz.id,
      icon: questionIconFor(quiz.materialKind),
      label: quiz.name,
      hasPending: quiz.materialKind !== 'annotation' && !this.isAdmin() && isPending,
    })),
  );

  readonly questionsListAreChecked = computed(() => {
    const answerable = this.quizService
      .visibleQuizzes()
      .filter(({ quiz }) => quiz.materialKind !== 'annotation');
    return answerable.length > 0 && answerable.every(({ isPending }) => !isPending);
  });

  readonly isCheckedStudent = computed(() => this.questionsListAreChecked() && !this.isAdmin());

  openSelectedItem(itemId: string): void {
    const { quiz } = this.quizService.quizzes().find((item) => item.quiz.id === itemId) ?? {};
    if (!quiz) return;
    if (this.isAdmin() || quiz.materialKind === 'annotation') {
      this.quizService.startEditQuiz(quiz);
    } else {
      this.quizService.startAnswerQuiz(quiz);
    }
  }
}
